import { combineReducers } from 'redux';
import * as AuthReducer from './authReducer';
import * as DefaultReducer from './defaultReducer';
import * as MobileDeviceReducer from './mobileDeviceReducer';
import * as TranslationReducer from './translationReducer';
import * as BankAccountReducer from './bankAccountReducer';
import * as OverviewReducer from './overviewReducer';
import { routerReducer } from 'react-router-redux';
import * as OrdersReducer from './ordersReducer';
import * as AwardDetailsReducer from './awardDetailsReducer';
import * as OrderDetailsReducer from './orderDetailsReducer';
import * as SearchReducer from './searchReducer';

const rootReducer = combineReducers({
  displayMessage: DefaultReducer.displayMessage,
  infoMessage: DefaultReducer.infoMessage,
  displayLoader: DefaultReducer.displayLoader,
  authToken: AuthReducer.authToken,
  locale: AuthReducer.locale,
  routing: routerReducer,
  sideNavContent: DefaultReducer.sideNavContent,
  customerLogoUrl: DefaultReducer.customerLogoUrl,
  customerDateFormat: DefaultReducer.customerDateFormat,
  customerId: DefaultReducer.customerId,
  pairCode: MobileDeviceReducer.pairCode,
  mobileDevices: MobileDeviceReducer.mobileDevices,
  translations: TranslationReducer.translations,
  privacyPolicyLink: TranslationReducer.privacyPolicyLink,
  activityMenu: DefaultReducer.activityMenu,
  cartLink: DefaultReducer.cartLink,
  catalogPoints: DefaultReducer.catalogPoints,
  catalogSymbol: DefaultReducer.catalogSymbol,
  banks: DefaultReducer.banks,
  banksCatalog: DefaultReducer.banksCatalog,
  awards: DefaultReducer.awards,
  catalogs: DefaultReducer.catalogs,
  footerLinks: DefaultReducer.footerLinks,
  catalogLink: DefaultReducer.catalogLink,
  clientColors: DefaultReducer.clientColors,
  greeting: DefaultReducer.greeting,
  basePath: DefaultReducer.basePath,
  alertsCount: DefaultReducer.alertsCount,
  genericAlerts: DefaultReducer.genericAlerts,
  receiveAlerts: DefaultReducer.receiveAlerts,
  bankAccountFilters: BankAccountReducer.bankAccountFilters,
  tabSelected: DefaultReducer.tabSelected,
  pagination: BankAccountReducer.pagination,
  bankAccountTransactions: BankAccountReducer.bankAccountTransactions,
  viewsPerPage: BankAccountReducer.viewsPerPage,
  eventsNumber: BankAccountReducer.eventsNumber,
  displayNoBankTransactions: BankAccountReducer.displayNoBankTransactions,
  availableAccessCodeCount: BankAccountReducer.availableAccessCodeCount,
  activeBankId: DefaultReducer.activeBankId,
  overviewHistoryReceived: OverviewReducer.overviewHistoryReceived,
  overviewHistorySent: OverviewReducer.overviewHistorySent,
  overviewBankSummary: OverviewReducer.overviewBankSummary,
  overviewRecentOrders: OverviewReducer.overviewRecentOrders,
  overviewSkillsFinder: OverviewReducer.overviewSkillsFinder,
  overviewAlerts: OverviewReducer.overviewAlerts,
  bankNameSelected: DefaultReducer.bankNameSelected,
  printUrl: BankAccountReducer.printUrl,
  isDisplayReceivedActions: OverviewReducer.isDisplayReceivedActions,
  ordersList: OrdersReducer.ordersList,
  ordersFilters: OrdersReducer.ordersFilters,
  ordersPagination: OrdersReducer.ordersPagination,
  ordersViewsPerPage: OrdersReducer.ordersViewsPerPage,
  ordersEventsNumber: OrdersReducer.ordersEventsNumber,
  isDisplayeCardDialogActions: OverviewReducer.isDisplayeCardDialogActions,
  isDisplayNominationDialogActions: OverviewReducer.isDisplayNominationDialogActions,
  nominationActivityValues: OverviewReducer.nominationActivityValues,
  ecardActivityValues: OverviewReducer.ecardActivityValues,
  personalInfoValues: DefaultReducer.personalInfoValues,
  awardDetailValues: AwardDetailsReducer.awardDetailValues,
  orderDetailValues: OrderDetailsReducer.orderDetailValues,
  programsDropdownOpen: SearchReducer.programsDropdownOpen,
  ordersSearchDisplay: SearchReducer.ordersSearchDisplay,
  ordersSearchData: SearchReducer.ordersSearchData,
  downloadDropdownOpen: BankAccountReducer.downloadDropdownOpen,
  isDisplayBankDialogActions: BankAccountReducer.isDisplayBankDialogActions,
  isDisplayBankDetailsLink: BankAccountReducer.isDisplayBankDetailsLink,
  bankDetailValues: BankAccountReducer.bankDetailValues,
  isDisplayProgramDialogActions: BankAccountReducer.isDisplayProgramDialogActions,
  programDetailValues: BankAccountReducer.programDetailValues,
  isDisplayAlertsSection: OverviewReducer.isDisplayAlertsSection,
  isDisplaySkillsSection: OverviewReducer.isDisplaySkillsSection,
  isDisplayDetailsAlerts: BankAccountReducer.isDisplayDetailsAlerts,
  preferredLocale: DefaultReducer.preferredLocale,
  environment: AuthReducer.environment,
  hasGivenWidgetEnabled: DefaultReducer.hasGivenWidgetEnabled,
  isDisplayMessageDialog: DefaultReducer.isDisplayMessageDialog,
  activeLanguage: DefaultReducer.activeLanguage,
  permissionDisplayItems: OrdersReducer.permissionDisplayItems,
  orderSearch: SearchReducer.orderSearch,
  orderSearchPrograms: SearchReducer.orderSearchPrograms,
  searchOrdersList: SearchReducer.searchOrdersList,
  recentRangeList: SearchReducer.recentRangeList,
  selectedRange: SearchReducer.selectedRange,
  isRangeDropdownOpen: SearchReducer.isRangeDropdownOpen,
  recentOrdersList: SearchReducer.recentOrdersList,
  isDisplayRedeemLink: OverviewReducer.isDisplayRedeemLink,
  isDisplaySkillsLoader: OverviewReducer.isDisplaySkillsLoader,
  isLoading: DefaultReducer.isLoading,
  apiTimeOut: AuthReducer.apiTimeOut,
  victoriesHeaderPath: AuthReducer.victoriesHeaderPath,
  displaySessionTimeOut: DefaultReducer.displaySessionTimeOut,
  logoutValue: DefaultReducer.logoutValue,
  isDisplayAwardPoints: OverviewReducer.isDisplayAwardPoints,
  isDisplayReplyLink: OverviewReducer.isDisplayReplyLink,
  isDisplaySideBarPanel: DefaultReducer.isDisplaySideBarPanel,
  avatarLink: DefaultReducer.avatarLink,
  monthsWeeks: DefaultReducer.monthsWeeks,
  isBankViewClicked: BankAccountReducer.isBankViewClicked,
  tasksCount: DefaultReducer.tasksCount,
  isDisplayOrdersSection: OverviewReducer.isDisplayOrdersSection,
  isDisplayBanksSection: OverviewReducer.isDisplayBanksSection,
  customerTitle: DefaultReducer.customerTitle,
  pageDropdownOpen: DefaultReducer.pageDropdownOpen,
  selectedDropDownValue: DefaultReducer.selectedDropDownValue,
  isDisplayCommonHeaderSideMenu: DefaultReducer.isDisplayCommonHeaderSideMenu,
  isDisplayFromDateCalendar: BankAccountReducer.isDisplayFromDateCalendar,
  isDisplayToDateCalendar: BankAccountReducer.isDisplayToDateCalendar,
  perfAPI: AuthReducer.perfAPI,
  translationApiUrl: AuthReducer.translationApiUrl,
  dateDisplayTimezone: AuthReducer.dateDisplayTimezone,
  customerSTP: DefaultReducer.customerSTP,
  translationsGreatwork: DefaultReducer.translationsGreatwork,
  isDisplayBankViewCatalog: BankAccountReducer.isDisplayBankViewCatalog,
  redeemPrograms: DefaultReducer.redeemPrograms,
  manuallyEnteredDate: BankAccountReducer.manuallyEnteredDate
});

export default rootReducer;
